import React from 'react';
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import ProgresoEstudiantesCatalog from './ProgresoEstudiantesCatalog';

export default function ProgresoEstudiantesPage() {
    return <ProgresoEstudiantesCatalog />;
}
